import { render, staticRenderFns } from "./single-choice-preview.vue?vue&type=template&id=fca49622&scoped=true&"
import script from "./single-choice-preview.vue?vue&type=script&lang=js&"
export * from "./single-choice-preview.vue?vue&type=script&lang=js&"
import style0 from "./single-choice-preview.vue?vue&type=style&index=0&id=fca49622&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca49622",
  null
  
)

component.options.__file = "single-choice-preview.vue"
export default component.exports